
import fileXLSX from '../assets/file-xlsx-solid-240.png';


export const ImageConfig = {
    default: fileXLSX,

}